import { Route, RouteComponentProps, Switch } from "react-router-dom";

import { NotFound } from "@app/shared/ErrorPages";
import EditRegionSet from "./EditRegionSet";
import { JSX } from "react";

export default function ProjectEditRouter(props: RouteComponentProps): JSX.Element {
  return (
    <Switch>
      <Route path={`${props.match.path}/service-area`} exact={true} component={EditRegionSet} />
      <Route component={NotFound} />
    </Switch>
  );
}
